declare global {
    interface String {
        removeAcentos(): string;
    }
}

// eslint-disable-next-line no-extend-native
String.prototype.removeAcentos = function () {
    return String(this).normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

export { }